<div fxLayout="column" fxLayoutGap="8px" fxFlex="100" class="disabled-form-input form-field-skeleton-wrapper">
  <mat-label *ngIf="label" class="b2 hint disable-form-input-label">{{ label }}</mat-label>
  <div class="disabled-input" fxFlex fxLayoutAlign="start center">
    <vdw-ellipsis-label [text]="getValue()" matTooltipPosition="above"> </vdw-ellipsis-label>
    <span matSuffix *ngIf="canShowUnit()">
      {{ getUnit() | bmsTranslate }}
    </span>
  </div>
</div>
